<template>
    <dv-full-screen-container ref="dvfullscreencontainer" style="position: static">
        <dv-loading v-show="loading">Loading...</dv-loading>
        <div :class="[isActive?'popUpBig popIn':'popUpBig']" :style="popWinStyle">
            <div class="popImg" v-if="popPics.length===1">
                <img :src="`/pedigreedata/${type}/${popPics[0]}`">
            </div>
            <div class="swiper-container" v-if="popPics.length>1">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="pic in popPics">
                        <img :src="`/pedigreedata/${type}/${pic}`">
                    </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
            </div>
        </div>
        <div v-if="fmaskShow" class="f-mask" @click="hidePopUp()"></div>
        <div class="datav-top">
            <div class="toptitle">
                <h2>{{title}}</h2>
                <p>{{titleEn}}</p>
            </div>
        </div>

        <div class="datav-layout">
            <div class="datav-left">
                <div class="m-pd20">
                    <h3 class="m-datatitle f-clear">规模匹配</h3>
                    <ul class="m-scalemate f-clear">
                        <li>
                            <h4 class="m-subtitle2 f-tac f-clear">供需总缺口</h4>
                            <div id="chart_allgap" style="width: 99%; height:2rem;"></div>
                        </li>
<!--                        <li>-->
<!--                            <h4 class="m-subtitle2 f-tac f-clear">本科缺口</h4>-->
<!--                            <div id="chart_bkgap" style="width: 99%; height:2rem;"></div>-->
<!--                        </li>-->
                        <li>
                            <h4 class="m-subtitle2 f-tac f-clear">学历层次缺口</h4>
                            <div id="chart_gzgap" style="width: 99%; height:2rem;"></div>
                        </li>
<!--                        <li>-->
<!--                            <h4 class="m-subtitle2 f-tac f-clear">中职缺口</h4>-->
<!--                            <div id="chart_zzgap" style="width: 99%; height:2rem;"></div>-->
<!--                        </li>-->
                    </ul>
                    <h3 class="m-datatitle f-clear">布局匹配</h3>
                    <div class="m-layoutmate f-clear">
                        <div class="item">
                            <p class="f-tac">企业规模TOP10</p>
                            <dv-scroll-ranking-board :config="config_industrytop10" style="width:100%; height:2.8rem; margin-top:0.3rem;" />
                        </div>
                        <div class="item">
                            <strong>VS</strong>
                        </div>
                        <div class="item">
                            <p class="f-tac">专业规模TOP10</p>
                            <dv-scroll-ranking-board :config="config_majortop10" style="width:100%; height:2.8rem; margin-top:0.3rem;" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="datav-main">
                <div class="m-pd10">
                    <div class="m-overviewtbox f-clear">
                        <h3 class="m-datatitle f-left"></h3>
                        <h3 class="m-datatitle f-right"></h3>
                        <strong>总览</strong>
                    </div>
                    <ul class="m-overview">
                        <li>
                            <h4 class="m-subtitle f-clear">人才需求</h4>
                            <div id="chart_allneed" style="width:100%; height:1.8rem;"></div>
                        </li>
                        <li>
                            <h4 class="m-subtitle f-clear">人才培养</h4>
                            <div id="chart_allprovide" style="width:100%; height:1.8rem;"></div>
                        </li>
                        <li>
                            <h4 class="m-subtitle f-clear">产业布局</h4>
                            <div id="chart_industrypos" style="width: 90%; height:1.65rem;"></div>
                        </li>
                        <li>
                            <h4 class="m-subtitle f-clear">专业布局</h4>
                            <div id="chart_majorpos" style="width: 90%; height:1.65rem;"></div>
                        </li>
                        <li class="m-majorchart" @click="showPopUp('gw')">
                            <h4 class="m-subtitle f-clear">岗位群</h4>
                            <div class="majorchart" v-if="jobpics.length===1">
                                <img :src="`/pedigreedata/${type}/${jobpics[0]}`">
                            </div>
                            <div class="swiper-container" v-if="jobpics.length>1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="pic in jobpics">
                                        <img :src="`/pedigreedata/${type}/${pic}`">
                                    </div>
                                </div>
                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>
                            </div>
                        </li>
                        <li class="m-majorchart" @click="showPopUp('zy')">
                            <h4 class="m-subtitle f-clear">专业群</h4>
                            <div class="majorchart" v-if="industrypics.length===1">
                                <img :src="`/pedigreedata/${type}/${industrypics[0]}`">
                            </div>
                            <div class="swiper-container" v-if="industrypics.length>1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="pic in industrypics">
                                        <img :src="`/pedigreedata/${type}/${pic}`">
                                    </div>
                                </div>
                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>
                            </div>
                        </li>
                        <li>
                            <h4 class="m-subtitle f-clear">职业岗位能力要求</h4>
                            <div id="chart_needkeywords" style="width: 90%; height:1.65rem; margin-top:0.2rem;"></div>
                        </li>
                        <li>
                            <h4 class="m-subtitle f-clear">专业培养能力要求</h4>
                            <div id="chart_providekeywords" style="width: 90%; height:1.65rem; margin-top:0.2rem;"></div>
                        </li>
                    </ul>

                </div>
            </div>
            <div class="datav-right">
                <div class="m-pd10">
                    <h3 class="m-datatitle f-clear">岗位-专业匹配</h3>
                    <div class="m-layoutmate mate2 f-clear">
                        <div class="item">
                            <p class="f-tac">岗位需求TOP</p>
                            <dv-scroll-ranking-board :config="config_jobneedstop10" style="width:100%; height:3.4rem; margin-top:0.3rem;" />
                        </div>
                        <div class="item">
                            <strong>VS</strong>
                        </div>
                        <div class="item">
                            <div style="height:1.8rem; position: relative; margin-bottom: 0.05rem;">
                                <p class="f-tac">中职-专业供给TOP</p>
                                <dv-scroll-ranking-board :config="config_jobprovidezztop5" style="width:100%; height:1.45rem; padding-top: 0.3rem;" />
                            </div>
                            <div style="height:1.85rem; position: relative;">
                                <p class="f-tac">高职-专业供给TOP</p>
                                <dv-scroll-ranking-board :config="config_jobprovidegztop5" style="width:100%; height:1.45rem; padding-top: 0.3rem;" />
                            </div>
                        </div>
                    </div>
                    <h3 class="m-datatitle f-clear">能力素质匹配</h3>
                    <div class="m-abilitymate">
                        <div class="item">
                            <h4 class="m-subtitle f-tal f-clear">岗位能力素质TOP10</h4>
                            <div class="m-postbox">
                                <div class="postbig" v-if="needkeywords.length>0" style="top: 0.4rem; left: 0;">{{needkeywords[0].name}}</div>
                                <div class="postbig" v-if="needkeywords.length>1" style="top: 0.4rem; right: 0;">{{needkeywords[1].name}}</div>
                                <div class="postmid" v-if="needkeywords.length>2" style="top: 0.3rem; left:1.1rem;">{{needkeywords[2].name}}</div>
                                <div class="postmid" v-if="needkeywords.length>3" style="top: 0.3rem; right:1.1rem;">{{needkeywords[3].name}}</div>
                                <div class="postmid2" v-if="needkeywords.length>4" style="top: 0.3rem; left:2rem;">{{needkeywords[4].name}}</div>
                                <div class="postmid2" v-if="needkeywords.length>5" style="top: 1.1rem; left:1rem;">{{needkeywords[5].name}}</div>
                                <div class="postmid2" v-if="needkeywords.length>6" style="top: 1.1rem; right:1rem;">{{needkeywords[6].name}}</div>
                                <div class="postsmall" v-if="needkeywords.length>7" style="top: 1.0rem; left:1.7rem;">{{needkeywords[7].name}}</div>
                                <div class="postsmall" v-if="needkeywords.length>8" style="top: 0.9rem; right:1.7rem;">{{needkeywords[8].name}}</div>
                                <div class="postsmall" v-if="needkeywords.length>9" style="top: 1.4rem; right:2.0rem;">{{needkeywords[9].name}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <h4 class="m-subtitle f-tac f-clear">中职能力素质TOP10</h4>
                            <dv-scroll-ranking-board :config="config_keywordzz" style="width:100%; height:2rem" />
                        </div>
                        <div class="item">
                            <h4 class="m-subtitle f-tac f-clear">高职能力素质TOP10</h4>
                            <dv-scroll-ranking-board :config="config_keywordgz" style="width:100%; height:2rem" />
                        </div>
<!--                        <div class="item">-->
<!--                            <h4 class="m-subtitle f-tac f-clear">本科</h4>-->
<!--                            <dv-scroll-ranking-board :config="config1" style="width:100%; height:1.6rem" />-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </dv-full-screen-container>
</template>

<script>
    import options from "./chartsoption.js";
    import echarts from "echarts";
    import "echarts-wordcloud";
    export default {
        name:"app",
        props:["type"],
        data() {
            return {
                loading: false,

                title:"",
                titleEn:"",
                jobpics:[],
                industrypics:[],
                needkeywords:[],

                config_keywordzz: {
                    data: [],
                    rowNum:5,
                    carousel: 'page',
                    valueFormatter:()=>""
                },
                config_keywordgz: {
                    data: [],
                    rowNum:5,
                    carousel: 'page',
                    valueFormatter:()=>""
                },
                config_industrytop10: {
                    data: [],
                    rowNum:'10',
                    carousel: 'page',
                    valueFormatter:()=>""
                },
                config_majortop10: {
                    data: [],
                    rowNum:'10',
                    carousel: 'page',
                    valueFormatter:()=>""
                },
                config_jobneedstop10: {
                    data: [],
                    rowNum:'10',
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_jobprovidezztop5: {
                    data: [],
                    rowNum:'5',
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_jobprovidegztop5: {
                    data: [],
                    rowNum:'5',
                    carousel: 'single',
                    valueFormatter:()=>""
                },

                chart_industrypos:null,
                chart_majorpos:null,
                chart_needkeywords:null,
                chart_providekeywords:null,
                isActive:false,
                popPics:[],
                popWinStyle:{
                    visibility: 'hidden',
                },
                fmaskShow:false,
            };
        },
        components: {
        },
        mounted(){
            // console.log(this.$refs.dvfullscreencontainer.ready);
            this.init();
        },
        methods: {
            async init(){
                this.loading = true;

                const data = await (await fetch(`/pedigreedata/${this.type}/data.json`)).json();
                // console.log(data);

                this.title = data.title;
                this.titleEn = data.titleEn;
                this.jobpics = data.jobpics;
                this.industrypics = data.industrypics;
                const that = this;

                const provincePos = {
                    "东部": ["北京", "天津", "河北", "上海", "江苏", "浙江", "福建", "山东", "广东", "海南", "辽宁", "吉林", "黑龙江"],
                    "中部": ["山西", "安徽", "江西", "河南", "湖北", "湖南"],
                    "西部": ["内蒙古", "广西", "重庆", "四川", "贵州", "云南", "西藏", "陕西", "甘肃", "青海", "宁夏", "新疆"],
                };

                data.industryprovince.sort(valuesort);
                data.majorprovince.sort(valuesort);
                this.config_industrytop10.data = data.industryprovince.slice(0,10);
                this.config_industrytop10 = {...this.config_industrytop10};
                this.config_majortop10.data = data.majorprovince.slice(0,10);
                this.config_majortop10 = {...this.config_majortop10};
                this.config_jobneedstop10.data = data.jobneedstop10;
                this.config_jobneedstop10 = {...this.config_jobneedstop10};
                this.config_jobprovidegztop5.data = data.jobprovidegztop5;
                this.config_jobprovidegztop5 = {...this.config_jobprovidegztop5};
                this.config_jobprovidezztop5.data = data.jobprovidezztop5;
                this.config_jobprovidezztop5 = {...this.config_jobprovidezztop5};
                this.config_keywordgz.data = data.gzprovidekeywords;
                this.config_keywordgz = {...this.config_keywordgz};
                this.config_keywordzz.data = data.zzprovidekeywords;
                this.config_keywordzz = {...this.config_keywordzz};

                if (this.type === "kd") {
                    options["gzgap"].series.splice(0,0, {
                        name: '高中及以下',
                        type: 'bar',
                        label: {
                            show: false,
                            position: 'inside'
                        },
                        barWidth:15,
                        data: [0,0,0],
                    });
                    options["allneed"].series.splice(0,0,{name:"高中及以下", type: 'bar', barWidth :10});
                    options["allprovide"].series.splice(0,0,{name:"高中及以下", type: 'bar', barWidth :10});
                    options["gzgap"].legend.data.splice(0,0, "高中及以下");
                    options["allneed"].legend.data.splice(0,0, "高中及以下");
                    options["allprovide"].legend.data.splice(0,0, "高中及以下");
                }

                for (let i = 1;i<data.allneed[0].length;i++) {
                    options["gzgap"].series[i-1].data = [
                        data.allneed[0][i] - data.allprovide[0][i],
                        data.allneed[1][i] - data.allprovide[1][i],
                        data.allneed[2][i] - data.allprovide[2][i],
                    ];
                }
                // console.log(data.allneed);
                // options["gzgap"].series[0].data = [
                //     data.allneed[0][1] - data.allprovide[0][1],
                //     data.allneed[1][1] - data.allprovide[1][1],
                //     data.allneed[2][1] - data.allprovide[2][1],
                // ];
                // options["gzgap"].series[1].data = [
                //     data.allneed[0][2] - data.allprovide[0][2],
                //     data.allneed[1][2] - data.allprovide[1][2],
                //     data.allneed[2][2] - data.allprovide[2][2],
                // ];
                // options["gzgap"].series[2].data = [
                //     data.allneed[0][3] - data.allprovide[0][3],
                //     data.allneed[1][3] - data.allprovide[1][3],
                //     data.allneed[2][3] - data.allprovide[2][3],
                // ];
                // options["allgap"].series[0].data = addArr(options["gzgap"].series[0].data,options["gzgap"].series[1].data,options["gzgap"].series[2].data);
                options["allgap"].series[0].data = addArr(...options["gzgap"].series.map(v=>v.data));
                options["allgap"].series[1].data = options["allgap"].series[0].data;

                let qk_year_arr = [];
                for(let i = 0; i < data.allneed.length; i++){
                    console.log(data.allneed[i][0]);
                    qk_year_arr[i] = data.allneed[i][0];
                }
                options["allgap"].xAxis[0].data = qk_year_arr;
                options["gzgap"].xAxis[0].data = qk_year_arr;

                data.allneed.forEach(v=>{
                    const l = v.length;
                    const a = v.slice(1);
                    v[l]=a.reduce((t,v)=>t+(v?v:0),0);
                    if (v[l]) {
                        v[l]/=a.reduce((t,v)=>t+(v?1:0),0);
                    }
                });
                data.allprovide.forEach(v=>{
                    const l = v.length;
                    const a = v.slice(1);
                    v[l]=a.reduce((t,v)=>t+(v?v:0),0);
                    if (v[l]) {
                        v[l]/=a.reduce((t,v)=>t+(v?1:0),0);
                    }
                });
                options.allneed.dataset.source=data.allneed;
                options.allprovide.dataset.source=data.allprovide;

                const industrypos = [];
                const majorpos = [];
                for (const pos in provincePos) {
                    industrypos.push({
                        name:pos,
                        value:data.industryprovince.reduce((t,v)=>t+(provincePos[pos].includes(v.name)?v.value:0),0)
                    });
                    majorpos.push({
                        name:pos,
                        value:data.majorprovince.reduce((t,v)=>t+(provincePos[pos].includes(v.name)?v.value:0),0)
                    });
                }
                options.industrypos.series[0].data = industrypos;
                options.majorpos.series[0].data = majorpos;
                options.needkeywords.series[0].data = data.needkeywords;
                this.needkeywords = data.needkeywords;

                const providekeywords = [...data.gzprovidekeywords,...data.zzprovidekeywords];
                providekeywords.sort(valuesort);
                options.providekeywords.series[0].data = providekeywords;

                this.loading = false;
                initEcharts(this);
            },
            showPopUp:function(type){
                if(type == 'gw'){
                    this.popPics = this.jobpics;
                }else if(type == 'zy'){
                    this.popPics = this.industrypics;
                }
                this.fmaskShow = true;
                this.popWinStyle = {
                    visibility: 'visible',
                };
                this.$nextTick(()=>{
                    var swiper = new Swiper('.popUpBig .swiper-container', {
                        pagination: {
                            el: '.swiper-pagination',
                        },
                        autoplay : {
                            delay:3000
                        },
                    });
                });
                this.isActive = true;
            },
            hidePopUp:function(){
                this.fmaskShow = false;
                this.popWinStyle = {
                    visibility: 'hidden',
                };
                this.isActive = false;
            }
        }
    };


    const initEcharts = async (vue)=> {
        // console.log(document.getElementById('chart_industry'));
        await waitfor(()=>vue.$refs.dvfullscreencontainer.ready, 10, 0);
        vue.chart_allgap = echarts.init(document.getElementById('chart_allgap'));
        vue.chart_allgap.setOption(options.allgap);
        // vue.chart_bkgap = echarts.init(document.getElementById('chart_bkgap'));
        // vue.chart_bkgap.setOption(options.bkgap);
        // vue.chart_zzgap = echarts.init(document.getElementById('chart_zzgap'));
        // vue.chart_zzgap.setOption(options.zzgap);
        vue.chart_gzgap = echarts.init(document.getElementById('chart_gzgap'));
        vue.chart_gzgap.setOption(options.gzgap);

        vue.chart_allneed = echarts.init(document.getElementById('chart_allneed'));
        vue.chart_allneed.setOption(options.allneed);
        vue.chart_allprovide = echarts.init(document.getElementById('chart_allprovide'));
        vue.chart_allprovide.setOption(options.allprovide);
        vue.chart_industrypos = echarts.init(document.getElementById('chart_industrypos'));
        vue.chart_industrypos.setOption(options.industrypos);
        vue.chart_majorpos = echarts.init(document.getElementById('chart_majorpos'));
        vue.chart_majorpos.setOption(options.majorpos);
        vue.chart_needkeywords = echarts.init(document.getElementById('chart_needkeywords'));
        vue.chart_needkeywords.setOption(options.needkeywords);
        vue.chart_providekeywords = echarts.init(document.getElementById('chart_providekeywords'));
        vue.chart_providekeywords.setOption(options.providekeywords);


        var swiper = new Swiper('.swiper-container', {
            pagination: {
                el: '.swiper-pagination',
            },
            autoplay:true,
        });
    };

    // const setDataBarAndLine = (option, data)=>{
    //     const cntarr = data.map(v=>v.cnt);
    //     const payarr = data.map(v=>v.payavg);
    //     option.series[0].data = cntarr;allneed
    //     option.series[1].data = payarr;
    //     option.xAxis[0].data = data.map(v=>v.name);
    //     option.yAxis[0].max = maxRoundnum(cntarr);
    //     option.yAxis[1].max = maxRoundnum(payarr);
    // };

    const setGap = (data, name)=>{
        data[name].provide = data[name].provide.map(v=>-v);
        data[name].gap = data[name].need.map((v,i)=>v+data[name].provide[i]);
        options[name].series[0].data = data[name].gap;
        options[name].series[1].data = data[name].provide;
        options[name].series[2].data = data[name].need;
    };

    const valuesort = (v1,v2)=>v2.value-v1.value;

    const addArr = (arr1,...arrn)=>{
        const arr = [];
        arr1.forEach((v,i)=>{
            arrn.forEach(arr=>{
                v+=arr[i];
            });
            arr.push(v);
        });
        return arr;
    };

    /**
     * 数字保留最高位
     */
    const roundnum = (n) => {
        const p = Math.pow(10, (n + "").length - 2);
        return (parseInt(n/p)) * p;
    };

    /**
     * 数组最大值保留最高位
     */
    const maxRoundnum = (arr) => roundnum(Math.max(...arr));

    /**
     * 学历排序
     * @type {string[]}
     */
    const eduIndexes = ["初中","中专","大专","本科","硕士","博士"];

    const sleep = (timeountMS) => new Promise((resolve) => {
        setTimeout(resolve, timeountMS);
    });
    const waitfor = async (f,max,i)=>{
        if (!f()) {
            await sleep(100);
            await waitfor(f,max,i+1);
        }
    };
</script>
<style>
    .popUpBig {
        width: 100%;
        height: 100%;
        /* display: none; */
        position: absolute;
    }

    .popUpBig .swiper-container,.popImg {
        /*width: 1000px;*/
        /*height: 600px;*/
        width:12rem;
        height:8rem;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10001;
        background: #050710;
        margin: auto auto;
        text-align: center;
    }

    .popUpBig .popImg img {
        width: 96%;
        height: 96%;
        margin: auto auto;
    }
    .f-mask {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10000;
        background: #000000;
        background-size: 100% 100%;
        opacity: 0.7;
        filter: progid:DXImageTransform.Microsoft.Alpha(opacity=70);
    }

    .popIn {
        -webkit-animation: fadeleftIn .5s;
        animation: fadeleftIn .5s;
        -webkit-animation-name: fadeleftIn;
        animation-name: fadeleftIn;
    }

    @-webkit-keyframes fadeleftIn {
        0% {
            -webkit-transform: scale3d(0, 0, 0);
            transform: scale3d(0.5, 0.5, 0.5);
            opacity: 0;
        }
        50% {
            -webkit-animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
            animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
        }
        100% {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
            -webkit-animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
            animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
            opacity: 1;
        }
    }
    @keyframes fadeleftIn {
        0% {
            -webkit-transform: scale3d(0, 0, 0);
            transform: scale3d(0.5, 0.5, 0.5);
            opacity: 0;
        }
        50% {
            -webkit-animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
            animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
        }
        100% {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
            -webkit-animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
            animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
            opacity: 1;
        }
    }
</style>
